import { render } from "./NewAIFormulaModalContent.vue?vue&type=template&id=61e16eb9&lang=true"
import script from "./NewAIFormulaModalContent.vue?vue&type=script&lang=js"
export * from "./NewAIFormulaModalContent.vue?vue&type=script&lang=js"
script.render = render

export default script